export default __webpack_public_path__ + "static/media/community3.73bcc6ac.jpg";